<br><br><br><br>
<div class="page-title">
  <mat-icon class="app-icon">file_save</mat-icon>
  <h1 class="title-text">JSA PDF Downloader</h1>
  <p class="form-desc">
    Below, please select an input for 'Office Reporting To' and choose a date range. Upon submitting, you will be able
    to select which matched JSA submissions you need to download as a PDF file.
  </p>
</div>
<br />

<mat-card class="mat-mdc-elevation-specific mat-elevation-z8">
  <mat-card-content>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <!-- Office Reporting To -->
      <mat-form-field appearance="fill">
        <mat-label>Office Reporting To</mat-label>
        <mat-select formControlName="office">
          <mat-option value="houston">Houston</mat-option>
          <mat-option value="ftworth">Ft. Worth</mat-option>
          <mat-option value="austin">Austin</mat-option>
          <mat-option value="irving">Irving</mat-option>
          <mat-option value="frisco">Frisco</mat-option>
          <mat-option value="bossiercity">Bossier City</mat-option>
          <mat-option value="magnolia">Magnolia</mat-option>
          <mat-option value="windsor">Windsor</mat-option>
          <mat-option value="midland">Midland</mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Date -->
      <mat-form-field appearance="fill">
        <mat-label>Start Date</mat-label>
        <input matInput [matDatepicker]="startPicker" formControlName="startDate" />
        <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
        <mat-datepicker #startPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>End Date</mat-label>
        <input matInput [matDatepicker]="endPicker" formControlName="endDate" />
        <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
        <mat-datepicker #endPicker></mat-datepicker>
      </mat-form-field>

      <div class="submit-button">
        <button mat-raised-button color="primary" type="submit">Search</button>
      </div>

      <!-- Loading Spinner -->
      @if (isLoading) {
        <div class="custom-spinner-container">
          <div class="custom-spinner"></div>
        </div>
      }

      <!-- No Data Message -->
      @if (!isLoading && searchConducted && dataSource.data.length === 0) {
        <div class="no-data-message">
          No matching JSA data found for the selected parameters.
        </div>
      }
    </form>
    <br />
  </mat-card-content>
</mat-card>
<br /><br />
<hr class="hr" />
<br /><br />

<!-- Table displaying results -->
<div class="table-header">
  <div class="links-title">Your Downloadable JSA PDF Files:</div>
</div>
<div class="table-group">
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
    <!-- Office Column -->
    <ng-container matColumnDef="office">
      <th mat-header-cell *matHeaderCellDef>Office</th>
      <td mat-cell *matCellDef="let element">{{ element.office }}</td>
    </ng-container>

    <!-- Date Column -->
    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef>Date</th>
      <td mat-cell *matCellDef="let element">{{ element.date | date : 'M/d/yyyy' : 'UTC'}}</td>
    </ng-container>

    <!-- Project Number Column -->
    <ng-container matColumnDef="projectNumber">
      <th mat-header-cell *matHeaderCellDef>Project Number</th>
      <td mat-cell *matCellDef="let element">{{ element.projectNumber }}</td>
    </ng-container>

    <!-- Client Name Column -->
    <ng-container matColumnDef="clientName">
      <th mat-header-cell *matHeaderCellDef>Client Name</th>
      <td mat-cell *matCellDef="let element">{{ element.clientName }}</td>
    </ng-container>

    <!-- Project Name Column -->
    <ng-container matColumnDef="projectName">
      <th mat-header-cell *matHeaderCellDef>Project Name</th>
      <td mat-cell *matCellDef="let element">{{ element.projectName }}</td>
    </ng-container>

    <!-- File -->
    <ng-container matColumnDef="fileUrl">
      <th mat-header-cell *matHeaderCellDef>PDF File</th>
      <td mat-cell *matCellDef="let element">
        <a [href]="element.fileUrl" target="_blank" rel="noopener noreferrer">View PDF</a>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row"></tr>
  </table>
</div>
<br /><br />

